/// TYPES ///
import { IShopArea } from "api/types/shop_quote/area";
import { IShopCounter } from "api/types/shop_quote/counter";
import { IShopLabel } from "api/types/shop_quote/label";
import { Vector2 } from "api/types/sketch";
/// COMPONENTS ///
import QuotePrintCounters from "./shop_counter";
/// PDF COMPONENTS ///
import { View } from "@react-pdf/renderer";
import { Text } from "@react-pdf/renderer";
/// VALUES ///
import { getMaterialHeightDisplay } from "values/material";

interface Props {
  index: number,
  area: IShopArea,
  labels: IShopLabel[],
  counters: IShopCounter[],
  dimensions: Vector2
}

export default function ShopQuotePrintArea({ index, area, labels, counters, dimensions }: Props) {
  return (
    <View break={index > 0} style={{ paddingTop: "5px" }}>
      <View style={{ paddingLeft: "10px" }}>
        <Text style={{ fontFamily: "Montserrat", fontWeight: 400, fontSize: 10.5 }}>
          {area?.name ?? ""}: {`${area?.material_name ?? ""} ${area?.color_name ?? ""} ${getMaterialHeightDisplay(area?.material_thickness ?? "")}`}
        </Text>
      </View>
      <View style={{ marginTop: "15px", height: dimensions.Y, backgroundColor: "#fafafa", width: "100%" }}>
        <QuotePrintCounters counters={counters} labels={labels.filter(label => label?.area_uuid === area?.uuid)} />
      </View>
    </View>
  )
}
